// Container

import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import styled from 'styled-components'
import moment from 'moment'
import momentDurationFormat from 'moment-duration-format'
import AudioPlayer from '../AudioPlayer'

import ProgressBar from '../visuals/ProgressBar'

const Wrap = styled.div`
  text-align: center;
  min-width: 116px;
`

const ProgressBarStyled = styled(ProgressBar)`
  margin-left: 8px;
  margin-right: 8px;
`

const TimeIndicator = styled.span`
  position: relative;
  top: 3.5px;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  line-height: 15px;
  color: #fff;
`

const mapStateToProps = (state) => {
  let props = {
    trackMeta: state.currentTrack.meta,
    isPlaying: state.currentTrack.isPlaying,
    elapsedTime: state.currentTrack.elapsed || 0,
    trackDuration: state.currentTrack.meta.duration || 0
  }

  props.elapsedTimeFormatted = moment.duration(props.elapsedTime, 'seconds').format('mm:ss', {trim: false}),
  props.remainingTime = props.trackDuration - props.elapsedTime
  props.remainingTimeFormatted = moment.duration(props.remainingTime, 'seconds').format('mm:ss', {trim: false})

  return props
}

const mapDispatchToProps = (dispatch) => ({
  toggleCurrentTrack: (force) => dispatch(actions.toggleCurrentTrack(force)),
  seekCurrentTrack: (time) => dispatch(actions.seekCurrentTrack(time))
})

class TrackProgress extends Component {
  constructor (props) {
    super(props)
    this.state = {
      shouldSeekPreview: false,
      seekElapsedTime: null,
      seekElapsedTimeFormatted: null,
      seekRemainingTimeFormatted: null
    }
  }

  onSeekDown = (event) => {
    event.preventDefault()

    // Don't allow seeking if there's no track loaded
    if (Object.keys(this.props.trackMeta).length === 0)
      return

    this.props.toggleCurrentTrack(false)

    this.seekPreview(event)

    // Add the mouse move event dynamically
    this.moveEvent = window.addEventListener('mousemove', this.onSeekMove)
    this.upEvent = window.addEventListener('mouseup', this.onSeekUp)
  }

  onSeekMove = (event) => {
    this.seekPreview(event)
  }

  seekPreview = (event) => {
    const referencePoint = this.progressElement.getBoundingClientRect().left
    const mouse = event.clientX
    const pos = mouse - referencePoint
    const width = this.progressElement.getBoundingClientRect().width

    // Clamp to 90% for UX
    const percent = (pos / width).clamp(0, 0.99)
    const seekElapsedTime = percent * this.props.trackDuration
    const seekRemainingTime = this.props.trackDuration - seekElapsedTime

    const seekElapsedTimeFormatted = moment.duration(seekElapsedTime, 'seconds').format('mm:ss', {trim: false})
    const seekRemainingTimeFormatted = moment.duration(seekRemainingTime, 'seconds').format('mm:ss', {trim: false})

    this.setState({
      shouldSeekPreview: true,
      seekElapsedTime,
      seekElapsedTimeFormatted,
      seekRemainingTimeFormatted
    })
  }

  onSeekUp = (event) => {
    // Clear event listeners
    window.removeEventListener('mousemove', this.onSeekMove)
    window.removeEventListener('mouseup', this.onSeekUp)

    // perform seek
    this.props.seekCurrentTrack(this.state.seekElapsedTime)
    // AudioPlayer.props.seek(this.state.seekElapsedTime)
    // console.log(AudioPlayer)

    // play track
    this.props.toggleCurrentTrack(true)

    // disable preview
    this.setState({
      shouldSeekPreview: false,
      seekElapsedTime: null,
      seekElapsedTimeFormatted: null,
      seekRemainingTimeFormatted: null
    })
  }

  render () {
    const { props, state } = this
    return (
      <Wrap>
        <TimeIndicator>{state.shouldSeekPreview ? state.seekElapsedTimeFormatted : props.elapsedTimeFormatted}</TimeIndicator>
        <ProgressBarStyled ref={ref => this.progressElement = findDOMNode(ref)}
            onMouseDown={this.onSeekDown}
            value={state.shouldSeekPreview ? state.seekElapsedTime : props.elapsedTime}
            max={props.trackDuration}
            shadow={true}
            progressColor='#CCA633'
            spacing={39}
          />
        <TimeIndicator>{state.shouldSeekPreview ? state.seekRemainingTimeFormatted : props.remainingTimeFormatted }</TimeIndicator>
      </Wrap>
    )
  }
}

TrackProgress = connect(mapStateToProps, mapDispatchToProps)(TrackProgress)

/* From https://stackoverflow.com/a/11409944/546476 */
Number.prototype.clamp = function (min, max) {
  return Math.min(Math.max(this, min), max);
}

export default TrackProgress



// WEBPACK FOOTER //
// ./src/components/Bottombar/TrackProgress.js